(function (upp) {
    'use strict';
    upp

        .directive('cartCurrentPageTpl', [
        function () {

            return {
                restrict:'E',
                replace:true,
                template:'<current-page-tpl data-page-title="CART.KEY" data-page-key="cart"></current-page-tpl>'
            };
        }])
    ;
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/cart/directives/cart-current_section-directive.js